
import { BaseService, SanitizedResponse } from "../BaseService";
import { NoseurObject } from "@rivtn/noseur";
import { IAdministrator } from "../janus/geminus/AdministrationService";
import { RequestType } from "kyofuuc";

export interface IConsusFile {
    file_name: string;
    relative_path: string;
    replaced_existing: boolean;
    consus_download_url: string;
    storage_download_url: string;
}

export class ConsusService extends BaseService {

    protected static instance: ConsusService;

    private constructor() {
        super(process.env.REACT_APP_CONSUS_BASE_API_URL ?? "http://127.0.0.1:9305");
    }

    static getInstance() {
        if (!ConsusService.instance) ConsusService.instance = new ConsusService();
        return ConsusService.instance;
    }

    queryConsusFiles(folder: string): Promise<SanitizedResponse<IConsusFile>> {
        return this.report(this.transport.get("/api/v1/storage", { query: { folder } }));
    }

    deleteFiles(relativePaths: string[]): Promise<SanitizedResponse<IConsusFile>> {
        return this.report(this.transport.delete("/api/v1/storage/multiple", { data: relativePaths }));
    }

    uploadRawData(payload: NoseurObject<any>): Promise<SanitizedResponse<IConsusFile>> {
        return this.report(this.transport.post("/api/v1/storage/upload/json", payload));
    }

    uploadBinary(payload: NoseurObject<any>): Promise<SanitizedResponse<IConsusFile>> {
        let fullname = "";
        if (payload.fullname) fullname = ("/" + payload.fullname);
        return this.report(this.transport.post(`/api/v1/storage/upload/binary${fullname}`, payload.file, { requestType: RequestType.BUFFER }));
    }

    uploadFormData(payload: NoseurObject<any>): Promise<SanitizedResponse<IConsusFile>> {
        return this.report(this.transport.post("/api/v1/storage/form/data", payload, { requestType: RequestType.FORM_DATA }));
    }

}

